<template>
  <div class="line-separator">
    <div class="separator-content">
      <div class="separator-line"></div>
      <h3 v-if="title" class="separator-title">{{ title }}</h3>
      <div class="separator-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LineSeparator",
  props: {
    title: {
      default: '',
      type: String,
    }
  }
}
</script>

<style lang="scss" scoped>
.line-separator {
  width: 100%;
  margin: 30px 0; /* Increased margin for better separation */

  .separator-content {
    display: flex;
    align-items: center;
    gap: 20px; /* Increased gap */
  }

  .separator-line {
    flex: 1;
    height: 2px; /* Thicker line */
    background-color: var(--card-border);
  }

  .separator-title {
    font-size: 1.1rem; /* Slightly larger font size */
    font-weight: 700; /* Bolder font weight */
    color: var(--text-secondary);
    margin: 0;
    white-space: nowrap;
  }
}
</style>
